import { Observable } from "rxjs";
import { debounceTime, switchMap, tap } from "rxjs/operators";
import { TRoadblockAssignmentForm } from "../../../../domain/codecs/form/RoadblockAssignmentForm";
import { formOperation } from "../../wrappers/formOperation";
import { action } from "./actionFunctions";
import { TActionsDefinitionsList } from "./TAction";

export const actions: TActionsDefinitionsList = [
    action("CRM_ROADBLOCK_ASSIGNMENT_CHANGE", (obs$: Observable<TRoadblockAssignmentForm>, lens, set) => {
        obs$.pipe(
            tap((form) => set(lens.roadblock_assignment_page_form.children.roadblock_assignment_forms.where(({edited}) =>
                edited.roadblock_type === form.edited.roadblock_type
            ).set(form))),
            debounceTime(1000),
            switchMap((form) => formOperation("UpdateRoadblockAssignmentRules", form)),
            tap((response) => set(lens.roadblock_assignment_page_form.children.roadblock_assignment_forms.where(({edited}) =>
                edited.roadblock_type === response.edited.roadblock_type
            ).set(response))),
        ).subscribe();
    }),
];
